import React from 'react';
import { useSelector } from 'react-redux';
import { ListFiltersBar } from '../shared/table/ListFiltersBar';
import { TablePagination } from '../shared/table/TablePagination';
import { GroupTable } from './components';
import { useGroupListScreen } from './hooks';
import {
    formatGroupDate,
    groupSearchFieldLabelMap,
    groupSearchFieldOptions,
    groupStatusClassMap,
    groupStatusOptions,
} from './helpers';

export const GroupListScreen = () => {
    const { token } = useSelector((state) => state.auth);

    const {
        mappedGroups,
        isLoading,
        error,
        pagination,
        searchTerm,
        searchField,
        statusFilter,
        rowsPerPage,
        setOffset,
        handleRowsPerPageChange,
        handleSearchTermChange,
        handleSearchFieldChange,
        handleStatusFilterChange,
        handleClearFilters,
    } = useGroupListScreen({
        token,
    });

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card stretch stretch-full card__no-border">
                    <div className="card-body pt-1">
                        <ListFiltersBar
                            searchField={searchField}
                            onSearchFieldChange={handleSearchFieldChange}
                            searchFieldOptions={groupSearchFieldOptions}
                            searchTerm={searchTerm}
                            onSearchTermChange={handleSearchTermChange}
                            statusFilter={statusFilter}
                            onStatusFilterChange={handleStatusFilterChange}
                            statusOptions={groupStatusOptions}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleRowsPerPageChange}
                            onClearFilters={handleClearFilters}
                        />

                        {error && (
                            <div className="alert alert-danger py-2" role="alert">
                                {error}
                            </div>
                        )}

                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                            <div className="text-muted fs-12">
                                {searchTerm.trim()
                                    ? `Resultados para ${groupSearchFieldLabelMap[searchField] || 'Búsqueda'}: "${searchTerm.trim()}"`
                                    : 'Listado general de grupos'}
                            </div>
                            <div className="text-muted fs-12">Mostrando {mappedGroups.length} de {pagination.total}</div>
                        </div>

                        <GroupTable
                            groups={mappedGroups}
                            isLoading={isLoading}
                            statusClassMap={groupStatusClassMap}
                            formatDate={formatGroupDate}
                        />

                        <TablePagination
                            total={pagination.total}
                            limit={pagination.limit}
                            offset={pagination.offset}
                            hasNext={pagination.hasNext}
                            hasPrev={pagination.hasPrev}
                            onOffsetChange={setOffset}
                            isLoading={isLoading}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
